module.exports = __webpack_public_path__ + "img/deco-4.eaedc7a8.svg";